import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class AccountService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getAccountsList(page: number, pageSize: number = 10, filter: any): Observable<IPagedResults<any>> {
        let url = `Account/GetAll`;
        return super.getAll<any>(url);
    }

    public getSupportEmailList(accountId: number) {
        let url = `Account/GetSupportEmailList?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public getEmail(id: number) {
        let url = `Account/GetEmail?id=${id}`;
        return super.getById<any>(url);
    }

    public getAccount(id: number) {
        let url = `Account/Get?id=${id}`;
        return super.getById<any>(url);
    }

    public getAccountAdmin(id: number) {
        let url = `Account/GetAdmin?id=${id}`;
        return super.getById<any>(url);
    }

    public saveAccount(data) {
        let url = `Account/Save`;
        return super.save<any>(url, data);
    }

    public deleteEmail(data) {
        let url = `Account/DeleteEmail`;
        return super.save<any>(url, data);
    }

    public saveEmail(data) {
        let url = `Account/SaveSupportEmail`;
        return super.save<any>(url, data);
    }

    public deleteAccount(data) {
        let url = `Account/Delete`;
        return super.save<any>(url, data);
    }

    public getAccountIsDuplicateByName(companyName: string) {
        let url = `Account/IsDuplicate?companyName=${companyName}`;
        return super.getAll<any>(url);
    }

    public getCompanyTypesList() {
        let url = `Common/GetAllCompanyTypes`;
        return super.getAll<any>(url);
    }

    public savePopupMessage(model: any) {
        let url = `Account/Save/PopupMessage`;
        return super.save<any>(url, model);
    }

    public getAccountPopupMessage(id?: number): Observable<any> {
        let url = `Account/GetPopupMessage?id=${id}`;
        return super.getAll<any>(url);
    }

    public getEmailLogs(accountId: number, module: string, reportType: string, start: any, end: any ) {
        let url = `${module == 'Activity' ? 'Task': (module != 'Contracts' ? 'Incident': module)}/Logs?accountId=${accountId}&reportType=${reportType}&siteId=null&start=${start}&end=${end}`;
        return super.getAll<any>(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/account.service.ts